var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5463 21C25.2963 21 25.9563 20.59 26.2963 19.97L29.8763 13.48C30.2463 12.82 29.7663 12 29.0063 12H14.2063L13.2663 10H9.99634V12H11.9963L15.5963 19.59L14.2463 22.03C13.5163 23.37 14.4763 25 15.9963 25H27.9963V23H15.9963L17.0963 21H24.5463ZM15.1563 14H27.3063L24.5463 19H17.5263L15.1563 14ZM15.9963 26C14.8963 26 14.0063 26.9 14.0063 28C14.0063 29.1 14.8963 30 15.9963 30C17.0963 30 17.9963 29.1 17.9963 28C17.9963 26.9 17.0963 26 15.9963 26ZM25.9963 26C24.8963 26 24.0063 26.9 24.0063 28C24.0063 29.1 24.8963 30 25.9963 30C27.0963 30 27.9963 29.1 27.9963 28C27.9963 26.9 27.0963 26 25.9963 26Z",
    fill: "#3D454D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCart);
export default __webpack_public_path__ + "static/media/ic_cart.84648e7f015bf6c9bf853d486df610fc.svg";
export { ForwardRef as ReactComponent };